import {
	addClass,
	eventHandler,
	find,
	findAll,
	listener,
	removeClass
} from "../../../../../../../modules/vegas/js/util";

listener('click', '[data-cart="qty"] [data-qty]', function (el, e) {
	e.preventDefault();

	let container = el.closest('[data-cart="qty"]'),
		input = find('input', container),
		qty = find('[data-qty="total"]', container);

	if (!input) {
		return;
	}

	let value = parseFloat(input.value),
		max = parseInt(input.getAttribute('max')),
		step = parseFloat(container.dataset.step) || 1,
		btn = el.dataset.qty,
		unRemove = container.dataset.unremove || false;

	if (btn === 'trash') return true;

	let price = container.dataset.price,
		result = inputQtyResult(value, btn, step, 1),
		price_total = result * price;

	if (!isNaN(max)) {
		if (result <= max) {
			if (result > step) {
				input.value = result;
				if (qty) qty.innerText = result;
			} else {
				input.value = step;
				if (qty) qty.innerText = step;
			}
		} else {
			result = max;

			input.value = max;
			if (qty) qty.innerText = max;

			let text = container.dataset.maxText;
			if (text) {
				text = text.replace(':cnt', '' + max);
				alert(text);
			}
		}
	} else {
		input.value = result
		if (qty) qty.innerText = result;
	}

	if (max && max === result) {
		addClass(input, 'is-max')
	} else {
		removeClass(input, 'is-max');
	}

	if (result === step || result === 0 || result < step) {
		if (!unRemove) {
			let button = findAll('button', container);
			if (button.length) {
				setTimeout(() => {
					button[0].setAttribute('data-qty', 'trash');
				}, 1);
			}
		}
	} else {
		let button = findAll('button', container);
		if (button.length) {
			setTimeout(() => {
				button[0].setAttribute('data-qty', 'minus');
			}, 1);
		}
	}

	if (result) {
		eventHandler.on(container, 'change-counter', {
			cnt: result,
			price_total: price_total
		})
	}
});

listener('blur', 'input[name="total"]', function (el, e) {
	e.preventDefault();

	let max = parseFloat(el.getAttribute('max')),
		value = parseFloat(el.value);

	if (value > max) {
		let qtyPlus = find('[data-qty="plus"]');
		if (qtyPlus) {
			qtyPlus.click();
		}
	}

	if (value === 0 || value < 0) {
		el.value = 1;
	}
});

function inputQtyResult(val = 0, sign = '', step = 1, fixed = 0) {
	let result = step;

	if (sign && (sign === 'plus' || sign === 'minus')) {
		if (sign === 'plus') result = val + step;
		if (sign === 'minus') result = val - step;
		if (fixed > 0) result = result.toFixed(fixed);
	}

	return parseFloat(result);
}
